import { useEffect, useState } from "react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { ProfileFields, profileValid } from "@/components/onboarding/ProfileFields";
import { api, errMsg } from "@/lib/api";

export const DetailsSection = () => {
  const { onboarding, refreshOnboarding, setUser } = useAuth();
  const [value, setValue] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (onboarding?.profile && !value) setValue(onboarding.profile); }, [onboarding, value]);
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put("/profile/details", value);
      setUser((u) => ({ ...u, name: data.name }));
      await refreshOnboarding();
      toast.success("Profile saved.");
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  if (!value) return null;
  return (
    <section className="panel p-6 sm:p-8 space-y-5" data-testid="settings-details">
      <h2 className="text-lg font-semibold">Name, country & language</h2>
      <ProfileFields value={value} setValue={setValue} />
      <button data-testid="settings-details-save-button" disabled={!profileValid(value) || busy} onClick={save}
        className="h-10 px-5 rounded-full brand-gradient text-white text-sm font-semibold disabled:opacity-40">{busy ? "Saving…" : "Save profile"}</button>
    </section>
  );
};
